export const ADOBE_LINK_CLICK = 'link_click';

export const ADOBE_EXIT_LINK_CLICK = 'exitLinkClick';

export const ADOBE_ERROR = 'error_triggered';

export const ADOBE_PAGE_LOAD = 'page_load';

export const ADOBE_TRANSACTION = {
  START: 'transaction_start',
  STEP: 'transaction_step',
  COMPLETE: 'transaction_complete',
  ERROR: 'transaction_error',
  CANCEL: 'transaction_cancelled'  // Added as a part of rp surrender cancel transaction
};

export const ADOBE_REGISTRATION = {
  START: 'registration_start',
  COMPLETE: 'registration_complete',
  ERROR: 'registration_error',
};

export const ADOBE_LOGIN = {
  START: 'login_start',
  COMPLETE: 'login_complete',
  ERROR: 'login_error',
};